export default "__VITE_ASSET__DVtwbz2C__"